import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Text extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    field: PropTypes.object
  }

  state = {}

  getSpanPending(textSize, contenido) {
    let style = styles.pending
    if (textSize === 'medium') {
      style += ' ' + styles.medium
    } else if (textSize === 'large') {
      style += ' ' + styles.large
    }
    return <span className={style}>{contenido}</span>
  }

  getSpanContainer(textSize, contenido2) {
    console.log('getSpanContainer')
    let style = styles.container
    if (textSize === 'medium') {
      style += ' ' + styles.medium
    } else if (textSize === 'large') {
      style += ' ' + styles.large
    }
    return <span className={style}>{contenido2}</span>
  }

  render() {
    console.log('Show text render')
    let required = '(Opcional)'
    let textSize = this.props.field.textSize
    if (this.props.field && this.props.field.required) {
      required = '(Requerido)'
    }
    console.log('Field:' + JSON.stringify(this.props.field))
    if (!this.props.value) {
      return this.getSpanPending(textSize, 'Texto pendiente ' + required)
    }
    return this.getSpanContainer(textSize, this.props.value)
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Show/Text/index.js